import { DATE_TIME_FORMAT } from '@smarsh-cyber/shared/constants';
import moment from 'moment';
import momenttz from 'moment-timezone';

export const formatTimestamp = (
  value: number | string,
  format: string = DATE_TIME_FORMAT
) => {
  if (value) {
    const timezone = moment.tz.guess();
    return momenttz.utc(value).tz(timezone).format(format);
  }
  return null;
};

export const timezone = moment.tz.guess();

export const formatSecondsToHHMMSS = (seconds: number): string => {
  return moment.utc(seconds * 1000).format('HH:mm:ss');
};
